import {
  DataGrid,
  GridFooterContainer,
  GridPagination,
} from "@mui/x-data-grid";
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import useApiHttp from "../../../hooks/use-http";
import { useParams } from "react-router-dom";

export const NewGuestList = forwardRef(
  (
    {
      columns = [],
      type,
      guestType,
      tableReset,
      refetchTable,
      searchValue,
      setGuestList,
      filterOptions = {},
      propSortConfig,
      propSetSortConfig = () => {},
    },
    ref,
  ) => {
    const { id: eventId } = useParams();
    const signalRef = useRef(null);
    const { sendRequest: getGuestData, isLoading: guestDataLoading } =
      useApiHttp();
    const [paginationModel, setPaginationModel] = useState({
      pageSize: 25,
      page: 0,
    });
    const [sortConfig, setSortConfig] = useState({
      sortBy: "createdAt",
      direction: "ASC",
    });
    const [rows, setRows] = useState([]);
    const [rowCount, setRowCount] = useState(0);

    const getGuestHandler = (type, page, size) => {
      signalRef.current = new AbortController();

      const body = {
        customFieldFilters: Object.entries(filterOptions).map(
          ([key, value]) => ({
            id: key,
            value: value,
          }),
        ),
      };
      getGuestData(
        {
          url: `event-attendee/custom-filter/${type}/${eventId}/guests?page=${page}&size=${size}&sortBy=${sortConfig?.sortBy}&direction=${sortConfig?.direction}${
            searchValue ? `&nameQuery=${searchValue}` : ""
          }`,
          method: "POST",
          body: body,
          signal: signalRef.current.signal,
        },
        null,
        (data) => {
          setGuestList(data?.results || data?.data);
          const updateData = data?.results || [];
          setRows(
            updateData.map((item, i) => {
              return { ...item, s_no: i + 1 + page * size };
            }),
          );
          setRowCount(data?.count);
        },
        (err, data) => {
          console.log("data", data);
        },
      );
    };
    const handlePagination = (e) => {
      getGuestHandler(type, e.page, e.pageSize);
    };
    const tableRefetchFun = () => {
      getGuestHandler(type, paginationModel.page, paginationModel.pageSize);
      console.log("hello123ref");
    };
    const tableResetFun = () => {
      console.log("hello123reset");
      const count = paginationModel.page * paginationModel.pageSize + 1;
      if (count == rowCount) {
        getGuestHandler(
          type,
          paginationModel.page - 1 > 0 ? paginationModel.page - 1 : 0,
          paginationModel.pageSize,
        );
        setPaginationModel({
          pageSize: paginationModel.pageSize,
          page: paginationModel.page - 1 > 0 ? paginationModel.page - 1 : 0,
        });
      } else {
        getGuestHandler(type, paginationModel.page, paginationModel.pageSize);
      }
    };

    useImperativeHandle(ref, () => ({
      tableRefetchFun: tableRefetchFun,
      tableResetFun: tableResetFun,
    }));

    useEffect(() => {
      getGuestHandler(type, 0, 25);
      setPaginationModel({
        pageSize: 25,
        page: 0,
      });
      return () => {
        signalRef?.current?.abort();
      };
    }, [type, searchValue, filterOptions, sortConfig]);
    useEffect(() => {
      setSortConfig(propSortConfig);
    }, [propSortConfig]);
    return (
      <div
        style={{
          height: "calc(100vh - 310px)",
          width: "100%",
        }}>
        <DataGrid
          loading={guestDataLoading}
          columns={columns}
          rows={rows}
          rowCount={rowCount}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 25,
              },
            },
          }}
          disableColumnMenu // Disables filter and column menu options
          disableRowSelectionOnClick // Keeps rows from being selected on click
          sx={{
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "var(--color-primary-50)", // Set the header background color
              color: "white", // Set the header text color
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontFamily: "var(--font-families-body-sbold)",
              fontSize: "var(--font-sizes-body-sbold)",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none", // Remove the border from individual cells
            },
            "& .MuiDataGrid-columnSeparator": {
              display: "none", // Remove the separator lines between column headers
            },
            "& .MuiDataGrid-cell:focus": {
              outline: "none", // This removes the active border on focus
            },
            "& .MuiDataGrid-cell:focus-within": {
              outline: "none", // This removes the active border on focus
            },
            "& .MuiDataGrid-columnHeader--sorted .MuiDataGrid-sortIcon": {
              color: "white", // color when column is actively sorted
            },
            // Scrollbar Styling
            "& .MuiDataGrid-virtualScroller": {
              "&::-webkit-scrollbar": {
                display: "block",
                width: "8px", // Width of the scrollbar
                height: "8px", // Height for horizontal scrollbar
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "rgba(0, 0, 0, 0.3)", // Color of the thumb
                borderRadius: "10px", // Optional: round the thumb
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#f1f1f1", // Track color
              },
            },
          }}
          pageSizeOptions={[25, 50, 75, 100]}
          paginationModel={paginationModel}
          paginationMode="server"
          onPaginationModelChange={(e) => {
            setPaginationModel(e);
            handlePagination(e);
          }}
          slots={{
            footer: CustomFooter,
          }}
          sortingOrder={["asc", "desc"]}
          sortingMode="server"
          sortModel={[
            {
              field: sortConfig.sortBy,
              sort: sortConfig.direction.toLowerCase(),
            },
          ]}
          onSortModelChange={(model) => {
            console.log("hello12345==>", model);
            if (!model.length) return;

            setSortConfig({
              sortBy: model[0].field,
              direction: model[0].sort.toUpperCase(),
            });
            propSetSortConfig({
              sortBy: model[0].field,
              direction: model[0].sort.toUpperCase(),
            });
          }}
        />
      </div>
    );
  },
);

function CustomFooter() {
  return (
    <GridFooterContainer sx={{ justifyContent: "flex-start" }}>
      <GridPagination />
    </GridFooterContainer>
  );
}
